module.exports = __webpack_public_path__ + "static/media/UY.e529a297.svg";